export const faqs = [
  {
    question: "What is Property Vue?",
    answer:
      "Photo storage and tracking for construction teams. Upload job site photos, organize them by project, and find any image when you need proof of what was done.",
  },
  {
    question: "Why does photo tracking matter?",
    answer:
      "Construction jobs generate hundreds of photos. They end up scattered across text threads, personal phones, and cloud folders. When a dispute, back charge, warranty claim, or insurance review comes up, digging for that one photo costs time and money. Property Vue puts every photo in one searchable place with a timestamp.",
  },
  {
    question: "How much does it cost?",
    answer:
      "$20 a month. That covers unlimited photos, unlimited team members, and unlimited projects. No other fees.",
  },
  {
    question: "How do I get started?",
    answer:
      "Create an account, add a project, and start uploading photos. Email help@propertyvue.io if you need a hand.",
  },
];
